import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    safeStorages: [],
    safeMakes: [],
    safeModels: [],
}

const SafeStorageReducer = (state = initialStates, action: any) => {
    const {
        GET_SAFE_STORAGES,
        GET_SAFE_STORAGE_MAKES,
        GET_SAFE_STORAGE_MODELS,
    } = ClientActionTypes

    switch (action.type) {
        case GET_SAFE_STORAGES:
            return {
                ...state,
                safeStorages: action.payload,
            }
        case GET_SAFE_STORAGE_MAKES:
            return {
                ...state,
                safeMakes: action.payload,
            }
        case GET_SAFE_STORAGE_MODELS:
            return {
                ...state,
                safeModels: action.payload,
            }

        default:
            return { ...state }
    }
}

export default SafeStorageReducer
